import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MeetupLocation } from '../../schemes/checkout.dto';

export interface UserPosition {
    lat: number;
    lng: number;
}

interface State {
    location: MeetupLocation | null;
    countryCode: string;
    userCurrentPosition: UserPosition | null;
}

const initialState: State = {
    location: null,
    countryCode: 'UZ',
    userCurrentPosition: null
};

const slice = createSlice({
    name: 'meetupLocation',
    initialState,
    reducers: {
        setMeetupLocation(state, action: PayloadAction<MeetupLocation | null>) {
            state.location = action.payload;
        },
        setCountry(state, action: PayloadAction<string>) {
            state.countryCode = action.payload;
        },
        setUserCurrentPosition(state, action: PayloadAction<UserPosition | null>) {
            state.userCurrentPosition = action.payload;
        }
    }
});

export const { setMeetupLocation, setCountry, setUserCurrentPosition } = slice.actions;
export default slice.reducer;
